module.exports = __webpack_public_path__ + "static/media/img181.9fa9ba94.jpg";